module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/inspiration-reward-100.0c64f4a8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/inspiration-reward-100.png
// module id = 3788
// module chunks = 11